import { useAppSelector } from '@user/store/hooks'
import { FEATURES } from '@sales-center/common/tenantFeatures'
import { selectTenantFeatureById } from '@user/store/tenantFeatures'

export function useVoiceToTextEnabled() {
  const voiceToText = useAppSelector((state) =>
    selectTenantFeatureById(state, FEATURES.VoiceToText),
  )

  return voiceToText?.enabled ?? false
}
